<template>
  <el-container
    style="
      display: flex;
      justify-content: center;
      margin: 5vh 5vw;
      max-height: 90vh;
      overflow-y: auto;
      overflow-x: hidden;
    "
  >
    <el-card
      style="width: 700px; height: 590px"
      body-style="display: flex; flex-direction: column; justify-content:center; align-items: center; padding: 0"
    >
      <img
        class="img"
        src="../assets/Final Logo Transparent 2.svg"
        style="
          object-fit: cover;
          width: 300px;
          height: 200px;
          object-position: left center;
          margin: 50px 0 -40px 0;
        "
      />
      <div
        style="
          margin-top: 20px;
          width: 60%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        "
      >
        SAML Login successful, if you are not redirected automatically, please
        click <a href="#/environments">here</a>
      </div>
    </el-card>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import AuthenticationService from "../services/AuthenticationService";
import Helper from "../utilities/Helper";

/**
 * @vue-data {String} [email=null] - Current user's email address
 * @vue-data {String} [password=null] - Current user's password
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 */
export default {
  computed: {
    ...mapState(["isUserLoggedIn"]),
  },
  methods: {
    handleError: Helper.handleError,
  },
  async mounted() {
    const response = await AuthenticationService.whoami();

    console.log(response);

    this.$store.dispatch("setUserId", response.data.userId);
    this.$store.dispatch("setUserRole", response.data.userRole);
    this.$store.dispatch("setOrganizationId", response.data.organizationId);

    this.$router.push({ name: "environments" });
  },
};
</script>

<style scoped>
.el-link.is-underline:hover:after {
  border-bottom: none;
}
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
</style>
